import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function ExternalLink(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <g>
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fillRule: 'nonzero',
          }}
          transform="matrix(2 0 0 2 1.17 .67)"
          fill="currentColor"
          d="M.023 3.119c.069-.316.179-.61.385-.862.344-.417.784-.664 1.33-.687.833-.037 1.667-.014 2.502-.014.348 0 .582.179.66.458a.62.62 0 0 1-.6.789c-.807.004-1.614 0-2.416 0a.604.604 0 0 0-.39.128.63.63 0 0 0-.243.527V9.453c0 .412.252.665.665.665h5.981c.417 0 .665-.253.665-.67V7.065c0-.307.22-.55.531-.61.266-.05.564.124.67.395.04.1.045.21.045.316 0 .76.005 1.526 0 2.287-.004.839-.453 1.503-1.196 1.792-.128.05-.261.073-.394.106H1.581a1.889 1.889 0 0 1-1.068-.555 1.895 1.895 0 0 1-.5-1.013c.01-2.223.01-4.441.01-6.664Z"
        />
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fillRule: 'nonzero',
          }}
          transform="matrix(2 0 0 2 1.17 .67)"
          fill="currentColor"
          d="M11.023 4.774c-.078.243-.234.408-.49.463a.62.62 0 0 1-.743-.592c-.005-.678 0-1.36 0-2.04 0-.036.01-.077-.01-.114-.04.01-.063.046-.086.074C8.053 4.2 6.417 5.842 4.78 7.478c-.256.257-.572.293-.843.096a.62.62 0 0 1-.096-.916 1121090.002 1121090.002 0 0 1 4.982-4.982c.023-.023.06-.042.064-.083-.037-.018-.078-.01-.114-.01-.66 0-1.32-.008-1.976.005a.65.65 0 0 1-.664-.531.633.633 0 0 1 .453-.692.035.035 0 0 0 .019-.01h3.973c.225.078.372.23.45.45-.005 1.32-.005 2.644-.005 3.969Z"
        />
      </g>
    </IconWrapper>
  );
}
